<template>
  <div :class="['list-plus-preview', {flex : displayFlex}]">
      <le-ellipsis
        class="list-plus-preview__displayed-items"
        :content="displayedItems"
        :renderHtml="false"
        data-test="list_plus_value"
        ></le-ellipsis>
    <span
      v-if="items.length > maxItemsDisplay"
      :class="['list-plus-preview__plus-items', plusItemsFontClass, {border : borderPlusItems}]"
      v-tooltip.bottom="plusItemsTooltipOptions"
      data-test="list_plus_more_value"
      >{{ plusLabel }}</span>
  </div>
</template>

<script>
import { leEllipsis } from 'lp-vue-components';

export default {
  name: 'list-plus-preview',
  components: { leEllipsis },
  props: {
    items: {
      type: Array,
      required: true,
    },
    maxItemsDisplay: {
      type: Number,
      required: false,
      default: 1,
    },
    displayFlex: {
      type: Boolean,
      required: false,
      default: true,
    },
    borderPlusItems: {
      type: Boolean,
      required: false,
      default: true,
    },
    plusItemsFontClass: {
      type: String,
      required: false,
      default: 'default-font',
    },
  },
  computed: {
    displayedItems() {
      return this.items.length > 0 ? this.items.slice(0, this.maxItemsDisplay).join(', ') : '';
    },
    plusLabel() {
      return this.items.length > this.maxItemsDisplay ? `+${this.items.length - this.maxItemsDisplay}` : '';
    },
    plusItems() {
      return this.items.slice(this.maxItemsDisplay).join(', ');
    },
    displayItems() {
      return this.items.slice(0, this.maxItemsDisplay).join(', ');
    },
    plusItemsTooltipOptions() {
      return {
        content: this.plusItems,
        html: false,
        autoHide: false,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.list-plus-preview {
  &.flex {
    display: flex;
  }

  &__displayed-items {
    label {
      cursor: pointer;
    }
    max-width: calc(20ch - 40px);
    margin-right: 5px;
    display: inline;
  }

  &__plus-items {
    margin-right: 5px;
    cursor: pointer;
    display: inline;
    &.default-font {
      font-size: $font-size-x-small;
    }
    &.border {
      border: solid 0.75px $color-gray-88;
      border-radius: 4px;
    }
  }
}
</style>
